import React from "react";
import { IoChevronBack } from "react-icons/io5";
import logo from "../../images/resend.png";
import logo1 from "../../images/LogoDashboard.png";

import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { postForgetPass } from "../../Actions/actions";
import { toast } from "react-toastify";
import CustomToast from "../../Components/CustomToast/CustomToast";

export default function Resend() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { email } = location.state;

  const handeResend = () => {
    dispatch(
      postForgetPass(email, () => {
        toast.success(<CustomToast type={'Success'} message={'Resend Email Successfull'} />, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          icon:false,
          closeButton:false
        })
        
      })
    );
  };

  return (
    <div className="font-public min-h-screen flex flex-col items-center justify-center bg-white">
      <div className="absolute top-10 left-10">
        <img src={logo1} alt="Repotal Logo" className="w-[200px] h-auto" />{" "}
      </div>

      <div className="mb-6">
        <img src={logo} alt="Repotal Logo" className="w-20 h-auto" />
      </div>

      <h2 className="text-2xl font-semibold text-center text-[#361D32]">
        Request Sent
      </h2>
      <h2 className="text-2xl font-semibold text-center text-[#361D32] mb-4">
        Successfully!
      </h2>

      <p className="text-sm text-center text-gray-600 mb-10 w-[82.5%]  md:w-[50%]   lg:w-[38%]  sm:w-[60%] xl:w-[27.5%]">
        We've sent confirmation link to your email. Please open the link to
        verify your email.
      </p>

      <div className="flex items-center text-purple-900 font-medium cursor-pointer mb-6">
        <p className="text-sm text-center text-gray-600 mr-[5px]">
          Didn't received a link?
        </p>
        <p className="text-[#361D32]" onClick={handeResend}>
          Resend link
        </p>
      </div>

      <div
        onClick={() => {
          navigate("/");
        }}
        className="flex items-center text-[#361D32] font-medium cursor-pointer"
      >
        <IoChevronBack className="mr-1 text-black" />
        <p className="text-[#361D32]">Return to sign in</p>
      </div>
    </div>
  );
}
